import Base from "@/models/Base"
import type { IAddress } from "@/interfaces/IAddress"

class Address extends Base implements IAddress {
  line1: string
  line2: string
  city: string
  postalCode: string
  state: string
  country: string

  constructor(address?: any) {
    super(address)
    this.line1 = address?.line1 ?? null
    this.line2 = address?.line2 ?? null
    this.city = address?.city ?? null
    this.postalCode = address?.postalCode ?? null
    this.state = address?.state ?? null
    this.country = address?.country ?? null
  }
}

export default Address
